module.exports = __webpack_public_path__ + "static/media/pern-stack.08bebef2.jpg";